.checkboxFormItemWithDescription {
  display: flex;
  align-items: center;
  margin-bottom: 1em;
}

.checkBoxDescription {
  padding: 0;
  margin-bottom: 0;
  margin-left: 0.5em;
}

.fontSizeAndNoMargin {
  margin-bottom: 0;
  font-size: 0.875rem;
}
